import { Button } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import type { SaveState } from "./useQuestionnaire";
import s from "./AutosaveChip.module.css";

export interface AutosaveChipProps {
  save: SaveState;
  onRetry(): void;
}

/** The four autosave states, rendered above the footer's primary button.
    `failed` is the only tappable one -- a real `<Button>`, reachable by
    keyboard and announced as actionable; the other three are
    `role="status" aria-live="polite"` so a screen reader hears the change
    without it stealing focus. */
export function AutosaveChip({ save, onRetry }: AutosaveChipProps) {
  const { t } = useTranslation("client");

  if (save === "failed") {
    return (
      <Button variant="ghost" className={s.failed} onClick={onRetry}>
        {t("questionnaire.autosave.failed", "Tallennus epäonnistui — yritä uudelleen")}
      </Button>
    );
  }

  const label =
    save === "saving"
      ? t("questionnaire.autosave.saving", "Tallennetaan…")
      : save === "offline"
        ? t("questionnaire.autosave.offline", "Tallennetaan, kun yhteys palaa")
        : t("questionnaire.autosave.saved", "Tallennettu");

  return (
    <span role="status" aria-live="polite" className={s.status}>
      {label}
    </span>
  );
}
